import { differenceInMonths } from 'date-fns';

/** Desloca um refMonth (ex: "2025_03") N meses para trás */
export const shiftRefMonthBack = (refMonth: string, months: number): string => {
  let year = Number(refMonth.slice(0, 4));
  let month = Number(refMonth.slice(-2)) - months;
  while (month <= 0) {
    month += 12;
    year--;
  }
  return `${year}_${month.toString().padStart(2, '0')}`;
};

export const getMonthQuantityBetweenRefMonth = (
  startRefMonth: string,
  endRefMonth: string
): number => {
  const startYear = startRefMonth.slice(0, 4);
  const startMonth = startRefMonth.slice(-2);

  const endYear = endRefMonth.slice(0, 4);
  const endMonth = endRefMonth.slice(-2);

  const startDate = new Date(`${startYear}-${startMonth}-01 GMT-0300`);
  const endDate = new Date(`${endYear}-${endMonth}-01 GMT-0300`);

  return Math.abs(differenceInMonths(endDate, startDate)) + 1;
};

export const getLastTwelveRefMonthList = () => {
  const date = new Date();
  const currentMonth = date.getMonth() + 1;

  let currentYear = date.getFullYear();

  const lastTwelveRefMonthList = [] as string[];

  for (let i = currentMonth; i >= 0; i--) {
    if (lastTwelveRefMonthList.length === 12) {
      break;
    }
    lastTwelveRefMonthList.push(
      `${currentYear}_${i.toString().padStart(2, '0')}`
    );
    if (i === 1) {
      i = 13;
      currentYear--;
    }
  }

  return lastTwelveRefMonthList;
};

export const getRefMonthList = (startRefMonth: string, endRefMonth: string) => {
  const startMonth = Number(startRefMonth.slice(-2));
  const startYear = Number(startRefMonth.slice(0, 4));

  const endMonth = Number(endRefMonth.slice(-2));
  const endYear = Number(endRefMonth.slice(0, 4));

  const refMonthList = [] as string[];

  let year = endYear;

  for (let i = endMonth; i >= 0; i--) {
    refMonthList.push(`${year}_${i.toString().padStart(2, '0')}`);

    if (i === startMonth && year === startYear) {
      break;
    }
    if (i === 1) {
      i = 13;
      year--;
    }
  }

  return refMonthList;
};
